import type { EntityConfig } from '../types'

export const mmOperationEntity: EntityConfig = {
  name: 'mm-operation',
  label: 'Operation',
  pluralLabel: 'Operations',
  status: {
    field: 'status',
    options: [],
    filters: [],
    mappings: {}
  },
  queryFields: {
    description: { field: 'description', type: 'text' },
    name: { field: 'name', type: 'text' },
    type: { field: 'type', type: 'text' },
    reference: { field: 'reference', type: 'text' },
  },
  uiFilterFields: ['type'],
}
